import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printReturnOrder } from './printReturnOrder';

export default {
    name: 'ReturnOrders',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewReturnOrdersUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.isFacilityUser) {
            this.loadEligibleOrders();
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.isMinistryStockAdminUi();
        },
        isFacilityUser() {
            return this.canCreateReturnOrdersUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي طلبات الإرجاع', this.pages, 'primary', 'ti ti-arrow-back-up'),
                this.statCard('طلبات مرسلة', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['مرسل'])), 'warning', 'ti ti-send'),
                this.statCard('طلبات مكتملة', this.countWhere(this.Info, item => this.matchStatus(item, [4], ['مكتمل'])), 'success', 'ti ti-circle-check'),
                this.statCard('طلبات مرفوضة', this.countWhere(this.Info, item => this.matchStatus(item, [5], ['مرفوض'])), 'danger', 'ti ti-ban'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            eligibleOrders: [],
            eligibleSearch: '',
            selectedOrderId: null,
            createForm: {
                reasonNote: '',
                lines: []
            },
            reviewDialog: false,
            reviewForm: {
                id: 0,
                approve: true,
                note: ''
            }
        };
    },

    methods: {
        statusBadgeClass(status) {
            if (status === 4) return 'bg-label-success';
            if (status === 5) return 'bg-label-danger';
            if (status === 3) return 'bg-label-primary';
            if (status === 2) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        statusLabel(s) {
            if (s === 1) return 'مسودة';
            if (s === 2) return 'مرسل';
            if (s === 3) return 'معتمد';
            if (s === 4) return 'مكتمل';
            if (s === 5) return 'مرفوض';
            return '-';
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetReturnOrders(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadEligibleOrders() {
            this.$http.GetEligibleReturnOrders(this.eligibleSearch)
                .then((response) => {
                    this.eligibleOrders = response.data.info || [];
                })
                .catch(() => {
                    this.eligibleOrders = [];
                });
        },
        onOrderChange() {
            this.createForm.lines = [];
            const selected = this.eligibleOrders.find((o) => o.id === this.selectedOrderId);
            if (!selected) return;
            this.$http.GetMedicineOrder(selected.id)
                .then((response) => {
                    const detail = response.data.info || {};
                    this.createForm.lines = (detail.lines || [])
                        .filter((line) => Number(line.quantityDispensed || 0) > 0)
                        .map((line) => ({
                            productsId: line.productsId,
                            productName: line.productName,
                            maxQty: Number(line.quantityDispensed || 0),
                            quantity: Number(line.quantityDispensed || 0),
                            lineNote: ''
                        }));
                });
        },
        openCreateDialog() {
            this.selectedOrderId = null;
            this.createForm = { reasonNote: '', lines: [] };
            this.eligibleSearch = '';
            this.loadEligibleOrders();
            this.createDialog = true;
        },
        clampLineQty(line) {
            let q = Number(line.quantity);
            if (isNaN(q) || q < 1) q = 1;
            if (q > line.maxQty) q = line.maxQty;
            line.quantity = q;
        },
        submitCreate() {
            const lines = (this.createForm.lines || [])
                .filter((line) => line.productsId && Number(line.quantity) > 0)
                .map((line) => ({
                    productsId: line.productsId,
                    quantity: Number(line.quantity),
                    lineNote: line.lineNote || null
                }));
            if (!this.selectedOrderId || !lines.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر طلباً وأضف بند إرجاع واحداً على الأقل.');
                return;
            }
            const body = {
                branchMedicineOrderId: this.selectedOrderId,
                reasonNote: this.createForm.reasonNote || null,
                lines
            };
            this.$blockUI.Start();
            this.$http.CreateReturnOrder(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إنشاء طلب الإرجاع.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetReturnOrder(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            if (!this.detail) return;
            this.reviewForm = {
                id: this.detail.id,
                approve: approve,
                note: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewReturnOrder(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkReturnOrderPrinted(this.detail.id)
                .then(() => {
                    const opened = printReturnOrder(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
